import authActionsTypes from '../actionTypes/authActionsTypes';

const initialStore = {
  isLoading: false,
  token: null,
  tokenBitteam: null,
  user: null,
};

const reducer = (state = initialStore, { type, payload }) => {
  switch (type) {
    case authActionsTypes.AUTH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case authActionsTypes.AUTH_SUCCESS:
      return {
        ...state,
        token: payload.token,
        tokenBitteam: payload.tokenBitteam,
        isLoading: false,
      };
    case authActionsTypes.AUTH_FAILURE:
      return {
        ...state,
        token: null,
        tokenBitteam: null,
        isLoading: false,
      };
    case authActionsTypes.AUTH_SIGNOUT:
      return {
        ...state,
        token: null,
        tokenBitteam: null,
      };
    case authActionsTypes.SAVE_USER_DATA:
      return {
        ...state,
        user: payload,
      };
    default:
      return state;
  }
};

export default reducer;
